import MonthlySummaryError from './MonthlySummaryError';
class MonthlySummaryPropertyNotHaveBricks extends MonthlySummaryError {
    propertyId;
    constructor(propertyId, options) {
        super('The number of bricks is more than the available', options);
        this.propertyId = propertyId;
    }
}
export default MonthlySummaryPropertyNotHaveBricks;
